import React from 'react'
import PropTypes from 'prop-types'
import { Navigate, useLocation } from 'react-router-dom'
import Cookies from 'js-cookie'
import { isTokenValid } from 'src/utils/authSession'
import { clearScreens } from 'src/utils/screens/screenStorage'
import { clearCurrentScreenId } from 'src/utils/screenId'

/**
 * Blocks unauthenticated access to app routes (dashboard + DefaultLayout children).
 * Redirects to /login and clears stale session data when the token is missing/invalid.
 */
function RequireAuth({ children }) {
  const location = useLocation()

  if (!isTokenValid()) {
    Cookies.remove('token')
    Cookies.remove('user_data')
    clearCurrentScreenId()
    clearScreens()
    try {
      localStorage.removeItem('userData')
    } catch {
      // ignore storage cleanup failures
    }

    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return children
}

RequireAuth.propTypes = {
  children: PropTypes.node,
}

export default RequireAuth
